import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { VoltixLogo } from "@/components/VoltixLogo";

export default function Login() {
  const nav = useNavigate();
  const { login, t } = useApp();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form.email, form.password);
      toast.success(`${u.name}`);
      nav(u.role === "admin" ? "/admin" : "/conta");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro");
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="flex justify-center mb-8"><VoltixLogo /></div>
      <div className="rounded-3xl border border-border p-8 bg-card">
        <h1 className="text-2xl font-display font-bold mb-2">{t("auth.login")}</h1>
        <p className="text-sm text-muted-foreground mb-6">{t("auth.loginSub")}</p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Email</Label><Input type="email" required value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} data-testid="login-email" /></div>
          <div><Label>{t("auth.password")}</Label><Input type="password" required value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})} data-testid="login-password" /></div>
          <Button type="submit" className="w-full rounded-full btn-primary" disabled={loading} data-testid="login-submit">
            {loading ? "..." : t("cta.login")}
          </Button>
        </form>
        <div className="mt-6 text-sm text-center text-muted-foreground">
          {t("auth.noAccount")} <Link to="/registar" className="text-primary hover:underline" data-testid="go-register">{t("auth.registerLink")}</Link>
        </div>
      </div>
    </div>
  );
}
